import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12542815"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "valid-table" }
const _hoisted_2 = { class: "table-title" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("上一步")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导入")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("下载校验数据")

import { computed, PropType, createVNode } from "vue";
import { VxeTablePropTypes } from "vxe-table";
import { Empty, message, Modal } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";

import { defineComponent } from "vue";
import { FormMultipleImportService } from "@/components/form-multiple-import/form-multiple-import.service";
const __default__ = defineComponent({
  name: "DataValid",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
  fail: {
    type: Number,
    default: 0,
  },
  total: {
    type: Number,
    default: 0,
  },
  tableHeight: {
    type: Number,
    default: 200,
  },
  columns: {
    type: Array,
    default: () => [],
  },
  uploadApiFn: {
    type: Function,
    required: true,
  },
  checkType: {
    type: String,
  },
  checkKey: {
    type: String,
  },
  isExtraUploadApiFn: {
    type: Boolean,
    default: false,
  },
  extraUploadApiFn: {
    type: Function,
  },
},
  emits: ["setSteps"],
  setup(__props, { emit }) {

const props = __props



const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;



const column = computed(() => {
  return [
    ...props.columns,
    { title: "校验结论", width: 200, dataIndex: "failDesc", key: "failDesc", fixed: "right" },
  ];
});

const cellClassName: VxeTablePropTypes.CellClassName = ({ row, column }) => {
  if (column.field === "failDesc") {
    return "color-red";
  }
  return "";
};

const { run, loading } = props.uploadApiFn();
const { run: runExport, loading: exportLoading } = FormMultipleImportService.useExportExcelData();

const exportExcel = async () => {
  let res = await runExport(props.checkKey, props.checkType);
  if (res.respCode !== "0000") {
    message.error(res.respDesc);
    return;
  }
  message.success(res.respDesc);
  if (res.data && res.data.url) {
    window.open(res.data.url);
  }
};

async function updateStep(step: number) {
  if (step === 3) {
    if (props.isExtraUploadApiFn) {
      Modal.confirm({
        title: "警告",
        icon: createVNode(ExclamationCircleOutlined),
        content: "库存导入会清空原有数据并替换为导入的新数据,请谨慎操作！",
        okText: "确定",
        centered: true,
        cancelText: "取消",
        onOk: async () => {
          const data = await run(props.data?.passList);
          if (data?.respCode === "0000") {
            emit("setSteps", step);
          }
        },
        onCancel() {},
      });
    } else {
      const data = await run(props.data?.passList);
      if (data?.respCode === "0000") {
        emit("setSteps", step);
      }
    }
  } else {
    emit("setSteps", step);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(`可导入数据${__props.data?.passList?.length || __props.data?.passList?.length || 0}条，${
          __props.data?.failList?.length && __props.data.failList.length > 0
            ? "部分数据校验失败，请检查清单内容，尝试重新导入"
            : ""
        }（校验失败：${__props.data?.failList?.length || 0}条）`), 1),
    _createVNode(_component_vxe_table, {
      border: "",
      data: __props.data?.failList,
      height: __props.tableHeight,
      "cell-class-name": cellClassName,
      "show-overflow": "tooltip"
    }, {
      empty: _withCtx(() => [
        _createVNode(_component_a_empty, { image: _unref(simpleImage) }, {
          description: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["image"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          fixed: "left",
          type: "seq",
          width: "80",
          align: "center",
          title: "序号"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(column), (item) => {
          return (_openBlock(), _createBlock(_component_vxe_column, {
            field: item.dataIndex || item.key,
            title: item.title,
            "min-width": item.width,
            fixed: item.fixed,
            align: "center",
            "show-overflow": "tooltip"
          }, null, 8, ["field", "title", "min-width", "fixed"]))
        }), 256))
      ]),
      _: 1
    }, 8, ["data", "height"]),
    _createVNode(_component_a_row, {
      type: "flex",
      align: "center",
      style: {"margin":"20px 0 0"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (updateStep(1)))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "primary",
              disabled: !__props.data?.passList?.length,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (updateStep(3))),
              loading: _unref(loading)
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["disabled", "loading"]),
            (__props.data?.failList?.length && __props.checkType && __props.checkType != '')
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (exportExcel())),
                  loading: _unref(loading) || _unref(exportLoading)
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})